module.exports = __webpack_public_path__ + "img/selected1-min.c1b4481f.png";